import React, { useEffect } from "react";
import { Container, Typography, Divider } from "@mui/material";
import SimpleHeader from "../components/SimpleHeader";

const SupportBot = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://www.gstatic.com/dialogflow-console/fast/messenger/bootstrap.js?v=1";
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <>
      <SimpleHeader />
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Support Bot
        </Typography>

        <Divider sx={{ my: 2 }} />

        <df-messenger
          intent="WELCOME"
          chat-title="FarmAppAssistant"
          agent-id="df03a6f6-c7f5-44e1-b311-d9f4804686fb"
          language-code="en"
        ></df-messenger>
      </Container>
    </>
  );
};

export default SupportBot;
